import React from 'react';
import { TopToolbar, RefreshButton, Toolbar, SaveButton, ListButton, ShowButton, Edit, SimpleForm, TextInput, NumberInput, required, email, maxLength } from 'react-admin';

const validateEmail = [email(), maxLength(50)];
const validateName = [required(), maxLength(50)];
const validateAddress = [maxLength(150)]
const validateContact = [maxLength(50)]

// const cardActionStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditToolbar = (props) => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

const EditActions = ({ permissions, basePath, data, resource }) => (
    <TopToolbar>
        <RefreshButton />
        <ListButton basePath={basePath} />
        <ShowButton basePath={basePath} record={data} />
    </TopToolbar>
)

const EditTitle = ({ record }) => {
    return <span>Edit Sold To - {record ? `${record.name}` : ''}</span>;
};

const BusinessesEdit = ({ permissions, ...props }) => (
    <Edit actions={<EditActions permissions={permissions} />} {...props} title={<EditTitle />} undoable={false}>
        <SimpleForm toolbar={<EditToolbar />}>
            <TextInput disabled source="user_name" />
            <TextInput source="phone" validate={required()} />
            <TextInput disabled source="sap_code" />
            <TextInput source="name" validate={validateName} />
            <TextInput source="email" validate={validateEmail} />
            <TextInput source="address" validate={validateAddress} />
            <TextInput source="contact_person" validate={validateContact} />
            {
              (permissions === 'isJDE' || permissions === 'isSageAPI') ?
              <TextInput disabled source="sap_digital_order_balance" />
              :
              <NumberInput source="sap_digital_order_balance" />
            }
            {
              (permissions === 'isJDE' || permissions === 'isSageAPI') ?
              <TextInput disabled source="orders_not_invoiced_price" />
              :
              <NumberInput source="orders_not_invoiced_price" />
            }
        </SimpleForm>
    </Edit>
);

export default BusinessesEdit;